import * as React from "react";
import { useLayoutEffect, useState } from "react";
const useRootTheme = () => {
  const [val, setVal] = useState("light");
  if (typeof document !== "undefined") {
    useLayoutEffect(() => {
      const classes = [...document.documentElement.classList];
      const isDark = classes.includes("t_dark");
      React.startTransition(() => {
        setVal(isDark ? "dark" : "light");
      });
    }, []);
  }
  return [val, setVal];
};
export {
  useRootTheme
};
//# sourceMappingURL=useRootTheme.js.map
